<template>
<svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 500 500" xml:space="preserve">
<g fill="currentColor">
<g>
<path d="M41.3,49.2c-4.5,4.8-9,9.6-13.6,14.2c-6.3,6.3-13.9,6.8-19.5,1.4c-5.9-5.6-5.6-13.4,0.9-19.9C21.3,32.6,33.6,20.3,45.9,8.1C52.6,1.5,59.5,1.4,66.2,8C78.6,20.3,91,32.7,103.3,45.2c6,6.1,6.3,14.2,0.8,19.6C98.7,70,91,69.7,84.9,64c-2.5-2.3-4.8-4.8-7.2-7.2c-2.3-2.4-4.6-5-7.9-8.5c0,128.2,0,254.8,0,381.9c126.5,0,253.2,0,381.2,0c-5.3-5.4-10.1-10.2-15-15c-3.6-3.5-5.5-7.7-4.5-12.7c1.9-9.7,14-14.3,21.2-7.5c14,13.2,27.4,27,40.8,40.8c4.7,4.9,4.4,11.9-0.5,16.9c-13,13.3-26.2,26.6-39.6,39.6c-5.4,5.3-13.2,4.9-18.3-0.3c-5.1-5.2-5.3-12.8-0.1-18.3c5-5.3,10.3-10.2,15.5-15.3c-0.2-0.5-0.4-0.9-0.6-1.4c-2.4,0-4.7,0-7.1,0c-127.4,0-254.9,0-382.3,0c-3,0-6.1,0-9-0.8c-5.7-1.6-8.6-6.8-8.6-14.3c0-30.5,0-61.1,0-91.6c0-98.6,0-197.2,0-295.8c0-1.5-0.1-2.9-0.2-4.4C42.3,49.7,41.8,49.4,41.3,49.2z"/>
<path d="M236.2,209c14.2,0.1,26.3,12.2,26.3,26.3c0,14.2-12.1,26.3-26.3,26.3c-14.1,0-26.3-12.1-26.3-26.3C209.8,221.4,222.2,209,236.2,209z"/>
<path d="M360,145.5c-14.4,0.1-26.4-11.6-26.6-25.9c-0.3-14.3,11.6-26.3,26-26.5c14.6-0.2,26.8,11.8,26.7,26.4C385.9,133.4,373.9,145.4,360,145.5z"/>
<path d="M199.4,367.4c0,14.3-11.9,26.3-26.2,26.3c-14.3,0.1-26.3-11.8-26.4-26.2c-0.1-14.1,12.1-26.4,26.2-26.4C187.2,341.2,199.3,353.2,199.4,367.4z"/>
<path d="M157.9,156.2c-0.1,14.4-12,26.2-26.3,26.1c-14.3-0.1-26.1-12.1-26-26.5c0.1-14.3,12.2-26.3,26.4-26.1C146.2,129.8,157.9,141.8,157.9,156.2z"/>
<path d="M395.8,325.6c-14.4-0.1-26.2-11.9-26.1-26.3c0.1-14.2,12.2-26.2,26.4-26.1c14.3,0.1,26.2,12.2,26.1,26.4C422.1,314,410.2,325.7,395.8,325.6z"/>
</g>
</g>
</svg>
</template>

<script>
export default {};
</script>



// WEBPACK FOOTER //
// src/components/shared/icons/IconCorrelations.vue